import { Typography } from "@mui/material";
import './TimerClock.scss'
import { useEffect, useState } from 'react';

interface TimerClockProps {
    createdAt: Date;
}

const TimerClock = (props: TimerClockProps) => {

    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    // const currentTime = new Date();
    const createdAt = new Date(props.createdAt);
    const timeDifference = createdAt.getTime() - currentTime.getTime() ;
    const remainingDays = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const remainingHours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const remainingMinutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));

    return(
        <div className="outermost-container">

            <div className="clock-outer-container">
                <div className="arrangement-container">
                <Typography className="remaining-days time-styling">{remainingDays}</Typography>
                <div className="vertical-divider"></div>
                <Typography className="remaining-hours time-styling">{remainingHours}</Typography>
                <div className="vertical-divider"></div>
                <Typography className="remaining-minutes time-styling">{remainingMinutes}</Typography>
                </div>
            </div>

            <div className="labels">
                <Typography className="time-label">Days</Typography>
                <Typography className="time-label">Hours</Typography>
                <Typography className="time-label">Mins</Typography>
            </div>

        </div>
    )
};

export default TimerClock;